export const OFFICIAL_CONTACTS = {
  organization: 'Comune di Casal Velino',
  address: 'Piazza XXIII Luglio, 6, 84040 Casal Velino (SA)',
  phone: '0974 908811',
  website: 'https://www.t-alento.it',
  websiteLabel: 'www.t-alento.it',
};

export const PROJECT_CREATOR = {
  name: 'The Thinking Clouds',
  website: 'https://www.thethinkingclouds.com',
  websiteLabel: 'www.thethinkingclouds.com',
};
